import React from 'react';
import { motion } from 'framer-motion';
export function CostTable() {
  const rows = [{
    sin: '3 hs de planificación × 40 semanas',
    costo: '120 horas de tu vida'
  }, {
    sin: 'Informes sin sistema',
    costo: '21 horas por año'
  }, {
    sin: 'Buscando archivos sin orden',
    costo: '26 horas por año'
  }, {
    sin: 'Actos improvisados cada vez',
    costo: 'Estrés repetido'
  }, {
    sin: 'Planificaciones rehachas cada año',
    costo: 'Trabajo que ya hiciste'
  }];
  return <section className="py-12 px-6" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <h2 className="text-3xl font-bold text-white mb-6 text-center" data-id="element-78">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-petroleo rounded-2xl overflow-hidden border border-petroleoLight mb-8" data-id="element-79">
          <table className="w-full text-left" data-id="element-80">
            <thead data-id="element-81">
              <tr className="bg-nocheLight border-b border-petroleoLight" data-id="element-82">
                <th className="p-6 text-gray-300 font-semibold" data-id="element-83">
                  Sin MegaPack
                </th>
                <th className="p-6 text-naranja font-semibold" data-id="element-84">Costo real</th>
              </tr>
            </thead>
            <tbody data-id="element-85">
              {rows.map((row, idx) => <tr key={idx} className="border-b border-petroleoLight last:border-0" data-id="element-86">
                  <td className="p-6 text-gray-200" data-id="element-87">{row.sin}</td>
                  <td className="p-6 text-white font-bold" data-id="element-88">{row.costo}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative p-8 md:p-12 text-center" data-id="element-89">
          <div className="absolute inset-0 border-2 border-tealBrand/30 rounded-3xl transform -skew-x-3" data-id="element-90"></div>
          <p className="relative z-10 text-xl md:text-2xl text-gray-200 font-medium leading-relaxed" data-id="element-91">
            El próximo domingo puede ser diferente.
            <br data-id="element-92" />
            <span className="text-tealBrand font-bold text-2xl md:text-3xl mt-4 block" data-id="element-93">
              "La próxima clase puede ser la mejor que diste." 🏫
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}